export const HANDLE_ENTERPRISE_INVITE = 'handle-enterprise-invite';
const handleEnterpriseInvite = () => ({ type: HANDLE_ENTERPRISE_INVITE });
export default handleEnterpriseInvite;
